import { registerBlockType } from '@wordpress/blocks';

// import { gtueIcon as icon } from '../common/gtue_icon';
import edit from './edit';
import metadata from './block.json';

const { name } = metadata;
export { metadata, name };

const blockStyle = {
    backgroundColor: '#900',
    color: '#fff',
    padding: '20px',
};

export default registerBlockType( 'gtue-newsroom/category-masonry', {
    title: 'Category Masonry List',
    keywords: ['GTÜ'],
    icon: {
    	background: '',
    	foreground: '',
    	src: <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"> <title>gtue-icon_s</title> <rect width="24" height="24" fill="none"/> <polygon points="20.9 7.62 24 7.62 24 8.62 20.9 8.62 20.9 7.62 20.9 7.62 20.9 7.62 20.9 7.62" fill="#d4072d" fill-rule="evenodd"/> <polygon points="16.87 7.62 20.43 7.62 20.43 8.62 16.87 8.62 16.87 7.62 16.87 7.62 16.87 7.62 16.87 7.62" fill="#d4072d" fill-rule="evenodd"/> <polygon points="9.56 9.34 16.16 9.34 16.16 12.44 14.59 12.44 14.59 16.47 11.13 16.47 11.13 12.44 9.56 12.44 9.56 9.34 9.56 9.34 9.56 9.34" fill="#d4072d" fill-rule="evenodd"/> <path d="M20.43,16.46h0a3.56,3.56,0,0,1-3.56-3.56h0V9.34h3.57v5.47h0a.23.23,0,1,0,.46,0h0V9.34H24v7.13H20.43Z" fill="#d4072d" fill-rule="evenodd"/> <path d="M1.71,12.9A3.57,3.57,0,0,1,5.28,9.34H8.84v3.1H5.28v2.37h0a.23.23,0,0,0,.46,0h0V12.9h3.1v3.57H5.28A3.57,3.57,0,0,1,1.71,12.9Z" fill="#d4072d" fill-rule="evenodd"/> <path d="M5.28,17.18H24v1H5.28a5.28,5.28,0,1,1,0-10.56H16.15v1H5.28a4.28,4.28,0,0,0,0,8.56Z" fill="#c5c5c6" fill-rule="evenodd"/> </svg>, },
    category: 'gtue-elements',
    "attributes": {
		"align": {
			"type": "string",
			"enum":  ["left", "center", "right", "wide", "full"]
		},
		"className": {
			"type": "string"
		},
		"categories": {
			"type": "array",
			"default": []
		},
		"eventCategories": {
			"type": "array",
			"default": []
		},
		"postsToShow": {
			"type": "number",
			"default": 5
		},
		"displayPostContent": {
			"type": "boolean",
			"default": false
		},
		"displayPostContentRadio": {
			"type": "string",
			"default": "excerpt"
		},
		"excerptLength": {
			"type": "number",
			"default": 55
		},
		"displayPostDate": {
			"type": "boolean",
			"default": false
		},
		"postLayout": {
			"type": "string",
			"default": "list"
		},
		"columns": {
			"type": "number",
			"default": 3
		},
		"order": {
			"type": "string",
			"default": "desc"
		},
		"orderBy": {
			"type": "string",
			"default": "date"
		},
		"displayFeaturedImage": {
			"type": "boolean",
			"default": false
		},
		"featuredImageAlign": {
			"type": "string",
			"enum": ["left", "center", "right"]
		},
		"featuredImageSizeSlug": {
			"type": "string",
			"default":"thumbnail"
		},
		"featuredImageSizeWidth": {
			"type": "number",
			"default":null
		},
		"featuredImageSizeHeight": {
			"type": "number",
			"default":null
		},
		"count": {
			"type": "number",
			"default": 3
		},
		"showFilter": {
			"type": "boolean",
			"default": true
		},
		"useAjax": {
			"type": "boolean",
			"default": true
		},
		"showTitel": {
			"type": "boolean",
			"default": true
		},
		"titel": {
			"type": "string",
			"default": 'GTÜ Intern <span class="gtue-strong"> Unser Blog</span>'
		},
                "titelMarkup": {
                    "type": "string",
                    "default": 'h1'
                }, 
	},
	edit,
} );